import styled from "styled-components";

export const Body = styled.div`

    height: 100vh;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #F2F1EE;
    background-image:
        repeating-linear-gradient(0deg, rgba(0, 0, 0, 0.03) 0 1px, transparent 1px 40px),
        repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.03) 0 1px, transparent 1px 40px);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    color: #171717;
`

export const BotaoLeft = styled.div`
    margin-top: 3vh;
    margin-left: 3vh;
    border: none;
    .left{ width: 5vw }

    img{
        border-radius: 50%;
        transition: transform 0.15s ease, box-shadow 0.15s ease;

        :hover{
            transform: scale(1.08);
            box-shadow: 0 0 0 4px rgba(240, 82, 79, 0.25);
            }
    }

    @media screen and (max-width: 760px) {
        display: none;
    }
`

export const TopoSeta = styled.div`

    display: flex ;
    flex-shrink: 0 ;
    margin-bottom: 1vh ;
`

export const DivDigital = styled.div`

    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5vh 3vw 1vh;
    box-sizing: border-box;
    overflow: hidden;

    .CalcDigital {

        width: 46vw;
        max-width: 650px;
        background-color: #fff;
        border: 2px solid #e2e2e2;
        border-radius: 1vw;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
        padding: 1.1vw 2.4vw 1.3vw;
        box-sizing: border-box;

            .topo {
                text-align: center;
                margin-bottom: 0.5vw;
                font-size: 1.4vw;
                font-weight: 800;
                color: #171717;
                line-height: 1.2;
            }

            hr { border: none; border-top: 2px solid #F5A623; margin: 0 0 0.6vw; };

            .titulo { margin-bottom: 0.5vw; text-align: left; }

            .subtitulo {
                font-size: 0.95vw;
                font-weight: 700;
                color: #171717;
                margin-bottom: 0.15vw;
            }

            .alerta {
                    font-size: 0.68vw;
                    color: #8a8a8a;
                    font-weight: 500;
                    margin-bottom: 0.2vw;
            }

            select, input {
                box-sizing: border-box;
                font-family: Verdana, Geneva, Tahoma, sans-serif;
                font-size: 0.95vw;
                padding: 0.35vw 0.7vw;
                border: 2px solid #e2e2e2;
                border-radius: 0.5vw;
                color: #171717;
                outline: none;
                transition: border-color 0.15s ease;

                :focus { border-color: #F0524F; }
                }

            select { width: 100%; }
            input { width: 70%; }

            button {
                display: block;
                width: 100%;
                margin-top: 0.4vw;
                background-color: #F0524F;
                color: #fff;
                font-weight: 700;
                font-size: 1.0vw;
                padding: 0.5vw;
                border: none;
                border-radius: 2vw;
                cursor: pointer;
                transition: background-color 0.2s ease;

                :hover{
                    background-color: #d63d3a;
                    }
            }

            .resultado{
                margin-top: 0.6vw;
                padding: 0.55vw;
                border-radius: 0.6vw;
                text-align: center;
                font-size: 1.0vw;
                font-weight: 700;
            }

            .resultado.sucesso {
                background: #e9f7ef;
                color: #1c7c3f;
                border: 2px solid #bfe8cd;
            }

            .resultado.pendente {
                background: transparent;
                color: #b23b38;
                font-weight: 600;
                font-size: 0.8vw;
                padding: 0.2vw 0;
            }

            .envio {
                margin-top: 0.7vw;
                padding-top: 0.6vw;
                border-top: 2px dashed #e2e2e2;

                .subtitulo { margin-bottom: 0.3vw; }

                .campo-email {
                    display: flex;
                    gap: 0.5vw;

                    input { flex: 1; }

                    button {
                        width: auto;
                        margin-top: 0;
                        padding: 0 1.2vw;
                        white-space: nowrap;
                    }
                }

                .envio-status {
                    margin-top: 0.3vw;
                    font-size: 0.78vw;
                    color: #1c7c3f;
                    font-weight: 600;
                }
            }
    }

    @media screen and (max-width: 760px) {

        padding: 1vh 5vw 6vh;

        .CalcDigital {
            width: 100%;
            max-width: none;
            border-radius: 3vw;
            padding: 6vw 6vw 8vw;

                .topo {
                font-size: 6vw ;
                margin-bottom: 4vw ;
                }

                hr{ margin-bottom: 4vw }

                .titulo { margin-bottom: 4vw; }

                .subtitulo{
                    font-size: 4vw;
                }

                .alerta{
                    font-size: 3vw;
                    margin-bottom: 1.5vw;
                }

                select, input {
                    width: 100%;
                    font-size: 4vw;
                    padding: 2.5vw 3vw;
                    border-radius: 2vw;
                }

                button {
                    font-size: 4.5vw;
                    padding: 3vw;
                    border-radius: 8vw;
                }

                .resultado{
                    font-size: 4vw;
                    padding: 3vw;
                }

                .resultado.pendente {
                    font-size: 3.4vw;
                }

                .envio {
                    .campo-email { flex-direction: column; }
                    .envio-status { font-size: 3.2vw; }
                }
        }
    }

`;
